import { createFileRoute } from "@tanstack/react-router";
import { routeHead } from "@/components/seo";
import { breadcrumbSchema, serviceSchema } from "@/lib/schema";
import { pageMeta, services } from "@/content";
import { serviceDetails } from "@/content/details";
import { DetailPage } from "@/components/detail-page";

const ROUTE = "/services/payroll";
export const Route = createFileRoute("/services/payroll")({
  head: () => {
    const p = pageMeta(ROUTE)!;
    return routeHead(ROUTE, {
      jsonLd: [
        serviceSchema({ name: "Payroll", description: p.description, url: ROUTE }),
        breadcrumbSchema([
          { name: "Home", item: "/" },
          { name: "Services", item: "/services" },
          { name: "Payroll", item: ROUTE },
        ]),
      ],
    });
  },
  component: Page,
});
function Page() {
  const p = pageMeta(ROUTE)!;
  return (
    <DetailPage
      eyebrow="Service"
      heading={p.h1}
      description={p.description}
      content={serviceDetails[ROUTE]}
      related={services
        .filter((s) => s.href !== ROUTE)
        .map((s) => ({ label: s.name, href: s.href }))}
    />
  );
}
